import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axiosInstance from "../../axiosInterceptor";
import { Eye, EyeOff } from "lucide-react";

const Login = () => {
  const navigator = useNavigate();
  const [apiError, setApiError] = useState("");

  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const [errors, setErrors] = useState({
    email: "",
    password: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setApiError("");

    try {
      const response = await axiosInstance.post("/admin/login", {
        email: data.email,
        password: data.password,
      });

      if (response.status === 200) {
        localStorage.setItem("kyrusToken", response.data.authToken);
        navigator("/dashboard");
      }
    } catch (error) {
      const msg = error.response?.data?.message || "Invalid email or password";

      setApiError(msg);

      setTimeout(() => {
        setApiError("");
      }, 5000);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="container-fluid page-body-wrapper full-page-wrapper">
      <div className="content-wrapper d-flex align-items-center auth">
        <div className="row flex-grow">
          <div className="col-lg-5 mx-auto ">
            <div
              className="auth-form-light text-left p-5"
              style={{ borderRadius: "10px" }}
            >
              <div className="brand-logo text-center">
                <img src="./logo.png" alt="Logo_img" />
              </div>
              <h4 className="text-left">Sign In to Your Kyrus Admin</h4>
              <p className="text-left">Enter your email & password to login</p>
              <form className="pt-2" onSubmit={handleSubmit}>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control form-control-sm border border-dark   "
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={data.email}
                    onChange={handleChange}
                  />
                  {errors.email && (
                    <p className="text-danger">{errors.email}</p>
                  )}
                </div>
                <div className="form-group position-relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control form-control-sm border border-dark"
                    id="password"
                    name="password"
                    placeholder="Password"
                    value={data.password}
                    onChange={handleChange}
                  />

                  <span className="eye-toggle" onClick={togglePassword}>
                    {showPassword ? (
                      <Eye size={20} strokeWidth={1.7} color="#fff" />
                    ) : (
                      <EyeOff size={20} strokeWidth={1.7} color="#fff" />
                    )}
                  </span>

                  {errors.password && (
                    <p className="text-danger">{errors.password}</p>
                  )}
                </div>
                <div className="mt-3">
                  <button
                    type="submit"
                    className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn d-flex align-items-center justify-content-center"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <i className="fa fa-spinner fa-spin mr-2"></i>
                        <span>Processing...</span>
                      </>
                    ) : (
                      "Login"
                    )}
                  </button>
                </div>

                <div className="d-flex justify-content-end">
                  <Link
                    to="/forgot-password"
                    className="d-inline-flex align-items-center
               text-decoration-none text-dark mt-4"
                  >
                    <span>Forgot Password?</span>
                    <i className="fa-solid fa-arrow-up-right-from-square ml-2"></i>
                  </Link>
                </div>
              </form>
              {apiError && (
                <div className="alert alert-danger py-2 mt-2 text-center">
                  {apiError}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
